<template>
  <div>
    <el-table
      :data="manufacturers"
      :stripe="true"
    >
      <el-table-column
        label="Name"
        :formatter="row => $_.get(row, 'name') || '-'"
      />
      <el-table-column
        label="Description"
        :formatter="row => $_.get(row, 'description') || '-'"
      />
      <el-table-column
        label="Created at"
        prop="created_at"
        :formatter="(row, col, cellValue) => cellValue ? $moment(cellValue).format('lll') : '-'"
      />
      <el-table-column
        label="Update at"
        prop="updated_at"
        :formatter="(row, col, cellValue) => cellValue ? $moment(cellValue).format('lll') : '-'"
      />
      <el-table-column
        label="Actions"
        align="right"
      >
        <template
          slot-scope="props"
        >
          <slot
            name="action"
            :Manufacturer="props.row"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  props: {
    manufacturers: {
      required: true,
      type: Array
    }
  }
}
</script>
